import {Content, useTranslation} from '@hconnect/uikit'
import {PageHeader, Button} from '@hm/fundamental'
import React from 'react'
import {useFormContext} from 'react-hook-form'
import {useHistory} from 'react-router'

import {SlotManagementConfig} from '../types/SlotManagementConfig'

import {SlotManagementConstraints} from './SlotManagementConstraints'
import {SlotManagementSettings} from './SlotManagementSettings'

type Props = {
  mode: 'edit' | 'create' | 'copy'
  configId?: string
  onSaveButtonClick: () => void
  isSubmitting: boolean
}

export const SlotManagementConfigurationDetails = ({
  mode,
  onSaveButtonClick,
  isSubmitting
}: Props) => {
  const {t} = useTranslation()
  const history = useHistory()
  const formMethods = useFormContext<SlotManagementConfig>()

  const title = (() => {
    switch (mode) {
      case 'edit':
        return t('configurations.hconnect.slotManagement.configurationDetails.titleEdit')
      case 'create':
        return t('configurations.hconnect.slotManagement.configurationDetails.titleCreate')
      case 'copy':
        return t('configurations.hconnect.slotManagement.configurationDetails.titleCopy')
    }
  })()

  const buttonText = (() => {
    switch (mode) {
      case 'edit':
        return t('configurations.hconnect.slotManagement.configurationDetails.buttonSave')
      case 'create':
        return t('configurations.hconnect.slotManagement.configurationDetails.buttonCreate')
      case 'copy':
        return t('configurations.hconnect.slotManagement.configurationDetails.buttonCopy')
    }
  })()

  return (
    <Content>
      <div className="[&_*:not(button):not(button_*)]:!text-white">
        <PageHeader
          data-cy={`slot-management-configuration-title-${mode}`}
          className="pl-0 pr-0 md:pl-0 md:pr-0"
          backToPageLabel={t('configurations.hconnect.slotManagement.configurationDetails.goBack')}
          backToPageUrlOnClick={() => history.goBack()}
          aside={
            <Button
              variant="secondary"
              onClick={onSaveButtonClick}
              disabled={!formMethods.formState.isValid || isSubmitting}
              data-test-id="slot-management-configuration-save-button"
            >
              {buttonText}
            </Button>
          }
        >
          {title}
        </PageHeader>
      </div>

      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-3">
          <SlotManagementConstraints isReadOnly={mode === 'edit'} />
        </div>
        <div className="col-span-12 lg:col-span-9">
          <SlotManagementSettings />
        </div>
      </div>
    </Content>
  )
}
